"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _InternalLink = require("./InternalLink");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const ExternalLink = props => /*#__PURE__*/_react.default.createElement(_InternalLink.StyledRegularLink, props);

ExternalLink.propTypes = {
  type: _propTypes.default.oneOf(['content', 'system', 'small']),
  target: _propTypes.default.string
};
ExternalLink.defaultProps = {
  type: 'system',
  target: '_blank'
};
var _default = ExternalLink;
exports.default = _default;